<template>
<div class="bookStatistics">
  <div class="module">
    <div class="item" style="width: 100%">
      <div class="title">图书汇总统计</div>
      <div class="content">
        <div class="bookNumber">
          <div>
            <p class="num">1500册</p>
            <p class="text">图书总册数</p>
          </div>
          <div>
            <p class="num">1500册</p>
            <p class="text">图书总价值</p>
          </div>
          <div>
            <p class="num">1500册</p>
            <p class="text">借阅总次数</p>
          </div>
          <div>
            <p class="num">1500册</p>
            <p class="text">中文图书</p>
          </div>
          <div>
            <p class="num">1500册</p>
            <p class="text">中文期刊</p>
          </div>
          <div>
            <p class="num">1500册</p>
            <p class="text">逾期未还书籍</p>
          </div>
          <div>
            <p class="num">1500册</p>
            <p class="text">逾期未还人数</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="module">
    <div class="item" style="width: 32.8%">
      <div class="title">近五年图书购置情况</div>
      <div class="content" id="bookShop"></div>
    </div>
    <div class="item" style="width: 32.8%">
      <div class="title">近五年图书借阅次数情况</div>
      <div class="content" id="bookBorrow"></div>
    </div>
    <div class="item" style="width: 32.8%">
      <div class="title">近五年图书流通情况</div>
      <div class="content" id="bookCirculate"></div>
    </div>
  </div>
  <div class="module">
    <div class="item" style="width: 32.8%">
      <div class="title">各学年人均借阅图书次数统计</div>
      <div class="content" id="borrowNumber">

      </div>
    </div>
    <div class="item" style="width: 32.8%">
      <div class="title">各学年图书借阅时长</div>
      <div class="content" id="borrowTime"></div>
    </div>
    <div class="item" style="width: 32.8%">
      <div class="title">各年级学生图书借阅</div>
      <div class="content" id="borrowGrade"></div>
    </div>
  </div>
  <div class="module">
    <div class="item" style="width: 100%">
      <div class="title">近五年热门图书</div>
      <div class="content" id="fiveHot"></div>
    </div>
  </div>
</div>
</template>

<script>
  export default {
    name: "bookStatistics",
    data () {
      return {
        staffColor: ['#1F89DF', '#49A3EC', '#6FB7F2', '#91C7AE', '#A2A860', '#91C7AE', '#EEC714', '#EEB814', '#6ABD9D'],
      }
    },
    methods: {
      drawBookShop() {
        let option = {
          color: this.staffColor,
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],
          series: [
            {
              name: '数量(册)',
              type: 'line',
              barWidth: '60%',
              data: [120, 200, 150, 80, 70, 110, 130],
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
              },
              barMaxWidth: 20,
            },
          ]
        };
        this.bookShopBox.setOption(option)
      },
      drawBookBorrow() {
        let option = {
          color: this.staffColor,
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],
          series: [
            {
              name: '借阅次数',
              type: 'line',
              barWidth: '60%',
              data: [120, 200, 150, 80, 70, 110, 130],
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
              },
              barMaxWidth: 20,
            },
          ]
        };
        this.bookBorrowBox.setOption(option)
      },
      drawBookCirculate () {
        let option = {
          color: this.staffColor,
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],
          series: [
            {
              name: '数量(册)',
              type: 'line',
              barWidth: '60%',
              data: [120, 200, 150, 80, 70, 110, 130],
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
              },
              barMaxWidth: 20,
            },
          ]
        };
        this.bookCirculateBox.setOption(option)
      },
      drawBorrowNumber () {
        let option = {
          color: this.staffColor,
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],
          dataZoom: [
            {
              show: true,
              start: 0,
              end: 100
            },
            {
              type: 'inside',
              start: 0,
              end: 100
            },

          ],
          series: [
            {
              name: '次数',
              type: 'line',
              barWidth: '60%',
              data: [120, 200, 150, 80, 70, 110, 130],
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
              },
              barMaxWidth: 20,
            },
          ]
        };
        this.borrowNumberBox.setOption(option)
      },
      drawBorrowTime () {
        let option = {
          color: this.staffColor,
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],
          dataZoom: [
            {
              show: true,
              start: 0,
              end: 100
            },
            {
              type: 'inside',
              start: 0,
              end: 100
            },

          ],
          series: [
            {
              name: '天数',
              type: 'line',
              barWidth: '60%',
              data: [120, 200, 150, 80, 70, 110, 130],
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
              },
              barMaxWidth: 20,
            },
          ]
        };
        this.borrowTimeBox.setOption(option)
      },
      drawBorrowGrade () {
        let option = {
          color: this.staffColor,
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],
          dataZoom: [
            {
              show: true,
              start: 0,
              end: 100
            },
            {
              type: 'inside',
              start: 0,
              end: 100
            },

          ],
          series: [
            {
              name: '图书量',
              type: 'bar',
              barWidth: '60%',
              data: [120, 200, 150, 80, 70, 110, 130],
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
              },
              barMaxWidth: 20,
            },
          ]
        };
        this.borrowGradeBox.setOption(option)
      },
      drawFiveHot () {
        let option = {
          color: this.staffColor,
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],

              type: 'category',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],
          series: [
            {
              name: '图书量',
              type: 'bar',
              barWidth: '60%',
              data: [120, 200, 150, 80, 70, 110, 130],
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
              },
              barMaxWidth: 20,
            },
          ]
        };
        this.fiveHotBox.setOption(option)
      }
    },
    mounted() {
      this.bookShopBox = this.$echarts.init(document.getElementById('bookShop'))
      this.bookBorrowBox = this.$echarts.init(document.getElementById('bookBorrow'))
      this.bookCirculateBox = this.$echarts.init(document.getElementById('bookCirculate'))
      this.borrowNumberBox = this.$echarts.init(document.getElementById('borrowNumber'))
      this.borrowTimeBox = this.$echarts.init(document.getElementById('borrowTime'))
      this.borrowGradeBox = this.$echarts.init(document.getElementById('borrowGrade'))
      this.fiveHotBox = this.$echarts.init(document.getElementById('fiveHot'))
      this.drawBookShop()
      this.drawBookBorrow()
      this.drawBookCirculate()
      this.drawBorrowNumber()
      this.drawBorrowTime()
      this.drawBorrowGrade()
      this.drawFiveHot()
      window.addEventListener('resize', () => {
        this.bookShopBox.resize()
        this.bookBorrowBox.resize()
        this.bookCirculateBox.resize()
        this.borrowNumberBox.resize()
        this.borrowTimeBox.resize()
        this.borrowGradeBox.resize()
        this.fiveHotBox.resize()
      })
    }
  }
</script>

<style lang="stylus" scoped>
  .bookStatistics
    width 100%
    color #333
    .module
      width 100%
      height 350px
      margin-top 25px
      display flex
      justify-content space-between
      .item
        width 49.5%
        height 100%
        background #fff
        border-radius 10px
        overflow hidden
        position relative
        .title
          width 100%
          height 20%
          display flex
          align-items center
          justify-content center
          font-size 18px
          font-weight bold
        .content
          width 100%
          height 80%
          .bookNumber
            width 100%
            height 100%
            display flex
            flex-wrap wrap
            justify-content space-around
            div
              width 14%
              display flex
              flex-direction column
              justify-content center
              align-items center
              .num
                font-size 26px
              .text
                font-size 18px
                margin-top 25px
</style>


// WEBPACK FOOTER //
// src/components/datanalysis/bookStatistics.vue